import React, { Fragment } from 'react'
import { withRouteData, Head } from 'react-static'

import { SITE_CONSTANTS } from '../../utils/constants'

import Picture from '../../components/Picture'
import DemoForm from '../../components/site/Forms/DemoForm'
import DemoFormB2B from '../../components/site/Forms/DemoFormB2B'
import SliderTestimonialCardStars from '../../components/site/TestimonialCardStars/SliderTestimonialCardStars'
import CardTrialNew from '../../blocks/CardFooter/CardTrialv2'

export default withRouteData(({ isB2b, card, children, hero, headData, distribuidor, footerCTAText }) => (
    <Fragment>
        {headData && <Head>
            <title>{headData.pageTitle}</title>
            <meta property="og:title" content={headData.pageTitle} />
            <meta name="twitter:title" content={headData.pageTitle} />
            <meta name="description" content={headData.pageDescription} />
            <meta property="og:description" content={headData.pageDescription} />
            <meta name="twitter:description" content={headData.pageDescription} />
            <meta property="og:image" content={headData.ogImage} />
            <meta name="twitter:image" content={headData.ogImage} />
            <meta property="og:url" content={headData.ogUrl} />
            <link rel="canonical" href={headData.ogUrl} />
        </Head>}

        <div className="new-layout new-representantes">
            {children}
            <section className='new-two-col'>
                <div className="container">
                    <h2 className='title'>Potencializamos você<br className='desktop-only' /> e seus produtos</h2>
                    <div className='col-content' >
                        <h3 className='content-text'>
                            Informações atualizadas dos produtos e clientes para vender com maior qualidade e agilidade.
                        </h3>
                        <div className="col-content-image-wrapper">
                            <Picture
                                className='hero-image'
                                src="/images/site/content/sem-internet.png"
                                alt='Sem internet'
                            />
                            <Picture
                                className='hero-image'
                                src="/images/site/content/google-play.png"
                                alt='Google Play'
                            />
                            <Picture
                                className='hero-image'
                                src="/images/site/content/apple-store.png"
                                alt='Apple Store'
                            />
                        </div>
                    </div>
                    <Picture
                        className='two-col-image'
                        src="/images/site/content/industrias/tela-mercos-1.png"
                        alt=' Tela do Mercos, sistema de vendas e pedidos para Representante Comercial'
                    />
                </div>
            </section>

            <section className='new-two-col reverse new-two-col-gestor'>
                <div className="container">
                    <h2 className='title'>Potencializamos <br className='desktop-only' /> sua gestão</h2>
                    <div className='col-content' >
                        <h3 className='content-text'>
                            Você tem uma visão clara e em tempo real de tudo que acontece com seus clientes, prepostos e comissões.
                        </h3>
                        <div className="col-content-image-wrapper">
                            <DemoForm trialAndDemo='teste grátis' modalLink showOr />
                        </div>
                    </div>
                    <Picture
                        className='two-col-image'
                        src="/images/site/content/industrias/analise.png"
                        alt='Telas de alguns indicadores de gestão do Mercos, sistema de vendas e pedidos para Representante Comercial'
                    />
                </div>
            </section>

            <section className='new-two-col '>
                <div className="container">
                    <h2 className='title'>Potencializamos<br className='desktop-only' /> a equipe de apoio
                    </h2>
                    <div className='col-content' >
                        <h3 className='content-text'>
                            Organize pedidos, clientes e tabelas de preços de todas as suas representadas e ganhe tempo para questões mais estratégicas.
                        </h3>

                    </div>
                    <Picture
                        className='two-col-image'
                        src="/images/site/content/industrias/equipe.png"
                        alt='Representante Comercial satisfeito com o Mercos'
                    />
                </div>
            </section>

            <section className="new-centered-cta">
                <div className="container">
                    <DemoForm trialAndDemo='teste grátis' modalLink showOr />
                </div>
            </section>

            <section className='new-two-col reverse'>
                <div className="container">
                    <h2 className='title'>Potencializamos <br className='desktop-only' />seu cliente</h2>
                    <div className='col-content' >
                        <h3 className='content-text'>Seu cliente terá um acesso exclusivo para explorar seus produtos, solicitar orçamentos e fazer pedidos através da internet 24h por dia, do computador ou celular.</h3>
                        <div className="col-content-image-wrapper">
                            <DemoFormB2B modaLink />
                        </div>
                    </div>
                    <Picture
                        className='two-col-image'
                        src="/images/site/landing-pages/forca-vendas/vendas-online.png"
                        alt=' Tela do e-commerce B2B da Mercos, loja online essencial para o Representante'
                    />
                </div>
            </section>
            <section className='new-two-col'>

                <div className="container">
                    <h2 className='title'>Potencializamos <br className='desktop-only' />suas ações de marketing</h2>
                    <div className='col-content' >
                        <h3 className='content-text'>Você poderá explorar campanhas digitais que direcionam diretamente para a realização de pedidos via internet.</h3>
                        <div className="col-content-image-wrapper">
                            <DemoFormB2B modaLink />
                        </div>
                    </div>
                    <Picture
                        className='two-col-image'
                        src="/images/site/content/industrias/marketing.png"
                        alt='Tela do Mercos, sistema de vendas e pedidos para Representante Comercial'
                    />
                </div>
            </section>
            <section className="testimonials">
                <SliderTestimonialCardStars descriptionH4 title="Mercos é o software de potencialização de vendas." representantes />
            </section>
            <CardTrialNew text={`Junte-se a mais de ${SITE_CONSTANTS.CLIENTS_COUNT} clientes que estão potencializando vendas`} horizontalCard modalLink />
        </div>


    </Fragment>
))



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/LandingPageBlocks/RepresentativeSections.jsx